// extracted by mini-css-extract-plugin
export default {"button":"GoogleCalendarButton_button__Gp65R","icon":"GoogleCalendarButton_icon__ZB3wP"};